import { render, staticRenderFns } from "./CartItemAmenity.vue?vue&type=template&id=001b5e7f&scoped=true&"
import script from "./CartItemAmenity.vue?vue&type=script&lang=js&"
export * from "./CartItemAmenity.vue?vue&type=script&lang=js&"
import style0 from "./CartItemAmenity.vue?vue&type=style&index=0&id=001b5e7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b5e7f",
  null
  
)

export default component.exports